import type { ElementType } from '@tunasong/schemas'
import { getElementMedia } from '../plugin/plugin-util.js'
import { usePlugins } from './editor-plugins.js'

export const useElementTypeMedia = (type?: ElementType) => {
  const plugins = usePlugins('all')
  const media = getElementMedia(type, plugins)
  return media
}
